// By default a question scores 1 only when ALL concept results on the final attempt
// are correct. Concept tags are not a reliable proxy for optimality (an optimal
// response can carry an uncredited concept), so callers with the grader's verdict
// pass per-question scores via questionScores, which win over the default.
// startingNumber lets Grammar offset numbering when Grammar questions follow
// Proofreader questions in a combined session.
export function embedQuestionNumbers<T extends { metadata: { attemptNumber?: number; correct?: number; questionNumber?: number; questionScore?: number } }>(
  nestedConceptResultArray: T[][],
  startingNumber = 0,
  questionScores?: Array<number | undefined>
): T[][] {
  return nestedConceptResultArray.map((conceptResultArray, index) => {
    const lastAttemptNumber = conceptResultArray.reduce((max, cr) => Math.max(max, cr.metadata.attemptNumber || 0), 0);
    const lastAttemptCRs = conceptResultArray.filter(cr => cr.metadata.attemptNumber === lastAttemptNumber);
    const questionScore = questionScores?.[index] ?? (lastAttemptCRs.length > 0 && lastAttemptCRs.every(cr => cr.metadata.correct === 1) ? 1 : 0);
    return conceptResultArray.map(conceptResult => {
      conceptResult.metadata.questionNumber = startingNumber + index + 1;
      conceptResult.metadata.questionScore = questionScore;
      return conceptResult;
    });
  });
}

export function calculateScoreFromConceptResults(conceptResults: Array<{ metadata: { questionNumber?: number; questionScore?: number } }>): number {
  const questionScores: {[key: number]: number} = {};
  conceptResults.forEach(cr => {
    const { questionNumber, questionScore } = cr.metadata;
    if (questionNumber !== undefined && !(questionNumber in questionScores)) {
      questionScores[questionNumber] = questionScore ?? 0;
    }
  });
  const scores = Object.values(questionScores);
  if (scores.length === 0) return 0;
  return Math.round((scores.reduce((sum, s) => sum + s, 0) / scores.length) * 100) / 100;
}
